<template lang="pug">
  .height-100
    transition(name="fade")
      editar-link-importante(
        :id="idSeleccionado"
        v-if="mostrarModalEditar",
        @close="closeModalEditar",
        @closeRefresh="closeModalEditar(true)"
        :class="{'modal-sidebar-desktop-open': showSidebarDesktop }"
      )


    transition-group.contenedor-box-transition(name="fade-smooth-two", tag="div")
      .box.lista-solicitud-vacaciones.contenedor-interno(key="box-lista")
        .title
          span Gestion de links importantes

        .message.is-info
          .message-body Los links cargados en esta pantalla, apareceran para todos los empleados activos de la plataforma

        .text-right
          button.button.is-small.margin-right-5.is-primary(@click="openModalEditar('')")
            span.icon.is-small
              i.fa.fa-plus
            span Nuevo
          button.button.is-small(@click="fetch")
            span.icon.is-small
              i.fa.fa-refresh
            span Refrescar

        .body
          .is-loading(v-if="isLoading")
            .icon
              i.fa.fa-spinner.fa-spin
          .information(v-else)
            template(v-if="lista.length !== 0")
              .is-desktop
                table.table.is-striped.is-bordered
                  thead
                    th Descripcion
                    th Ruta
                    th Fecha de modificación
                    th
                  tbody(
                    name="table-row"
                    is="transition-group"
                  )
                    tr.row-table(
                      v-for="(o, index) in lista"
                      :key="index"
                      :class="{'is-close': !o.activo}"
                      @dblclick="openModalEditar(o.id)"

                    )
                      td
                        .hint--top(:aria-label="'Orden: ' + o.orden")
                          .hint--bottom(:aria-label="'ID: ' + o.id") {{ o.descripcion }}
                      td {{ o.ruta }}
                      td {{ o.modificado }}
                      td.text-center
                        button.button.is-small(@click="openModalEditar(o.id)")
                          span.icon.is-small
                            i.fa.fa-pencil-square-o
                          span Editar
              .is-mobile
                .box(
                  v-for="(o, index) in lista"
                  :key="index"
                )
                  .descripcion-tipo.hint--top(:aria-label="'Orden: ' + o.orden")
                    span.hint--bottom(:aria-label="'ID: ' + o.id") {{ o.descripcion }}
                  .motivo
                    div
                      span {{ o.ruta }}
                  .dias-pedidos
                    strong Fecha de modificación:
                    div
                      span.detalle-dias {{ o.modificado }}
                  .botones
                    button.button.is-small(@click="openModalEditar(o.id)")
                      span.icon.is-small
                        i.fa.fa-pencil-square-o
                      span Editar
            div(v-else)
              .message.is-warning
                .message-body No hay links importantes ingresados
</template>

<script>
import EditarLinksImportante from '../components/c_gestion_links_importantes_editar'
import { apiGet, notify } from '../util/general'
export default {
  name: 'gestion-links-importantes',
  data () {
    return {
      lista              : [],
      isLoading          : false,
      mostrarModalEditar : false,
      idSeleccionado     : null
    }
  },
  computed : {
    showSidebarDesktop () {
      return this.$store.getters.showSidebarDesktop
    }
  },
  components: {
    'editar-link-importante': EditarLinksImportante
  },
  mounted () {
    this.fetch()
  },
  methods: {
    fetch () {
      var vm = this
      vm.isLoading = true

      var obj = {
      }

      apiGet(vm, '/links-importantes', obj, function (data) {
        vm.lista = data.lista
      }, function (error) {
        notify(vm, 'error', 'Error', error.message)
      }, function () {
        vm.isLoading = false
      })
    },
    openModalEditar (id) {
      var vm = this
      if (id) vm.idSeleccionado = id
      vm.mostrarModalEditar = true
    },
    closeModalEditar (refresh) {
      var vm = this
      vm.mostrarModalEditar = false
      vm.idSeleccionado = null
      if (refresh) vm.fetch()
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus" scoped>
  .contenedor-interno
    .close
      float right
      cursor pointer
      i
        font-size 16px

    .title
      font-size 16px
      span
        font-weight bold
        text-transform uppercase

  th
    text-align center

  .row-table
    transition all 0.3s ease
    &.is-close
      background-color #ffd6d6 !important


  .table-row-enter, .table-row-leave-active {
    opacity: 0
    height 0
  }

  .pop-over
    background: #fff;
    border-radius: 3px;
    border: 1px solid #d6dadc;
    border-bottom-color: #c4c9cc;
    -webkit-box-shadow: 0 1px 6px rgba(0,0,0,.15);
    box-shadow: 0 1px 6px rgba(0,0,0,.15);
    position: absolute;
    min-width: 300px
    width: 100%;
    z-index: 70;
    top 0

  .position-relative
    position relative

  .codigo-empleado
    position relative
    .control
      .input-container
        display flex
        align-items center
        .input
          flex 1
          width 100px
        .erase-data
          cursor pointer
          margin-left 5px

  .filtros-container
    padding-bottom 10px
    border-bottom 1px solid #ccc
    .title-filtro
      display flex
      text-align left
      padding-left 10px
      padding-bottom 10px
      margin-bottom 10px
      border-bottom 1px solid #ccc
      .text
        text-transform uppercase
        flex 1
      .caret
        cursor pointer

    .filtros
      margin-bottom 10px
      text-align left
      display flex
      align-items: flex-start;


      .filtro
        display inline-block
        border 1px solid #cccccc
        background-color #f9f9f9
        padding 5px
        margin 5px
        border-radius 3px
        flex 1
        max-width 25%
        .title-singular
          text-align left
          font-weight bold
          user-select: none
        .abierto-cerrado-container
          display flex
          .option
            padding 4px
            border 1px solid #565cde
            color #565cde
            cursor pointer
            transition all 0.3s ease
            height 31.5px

            &.selected
              background-color: #565cde;
              color: #fff;

        .list-container
          padding 0px 10px 0px 10px
          .option
            user-select: none
            cursor pointer
            &.selected
              color #565cde
              font-weight bold

  .boton-container
    button
      margin-left 5px



  .is-loading
    margin-top 10px

  .information
    padding-top 10px

  th
    vertical-align: middle;
  td
    vertical-align: middle;

  td
    .email
      font-size 12px
      color #9a9a9a

  .table
    font-size 13px

  .td-status
    width: 50px;

  .status
    align-items: center;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    .circle
      width: 25px;
      height: 25px;
      border-radius: 50%
      transition background ease-in .15s
      border 1px solid #d8d8d8
      background-color #23d160
      &.green
        background-color #23d160
      &.yellow
        background-color #ffdd57
      &.red
        background-color #ff0000
      &.white
        background-color #ffffff

  .status-container-filtro
    display flex
    justify-content center
    align-items center
    .status
      margin 5px
      cursor pointer
      .circle
        transition all ease-in .15s
        width: 30px;
        height: 30px;
      &.selected
        .circle
          border 2px solid #565cde
  .is-mobile
    display none
    .box
      position: relative;
    .status
      position:absolute;
      top: -3px
      right: 5px
      span {
        font-size: 10px;
        color #a5a5a5
        font-weight: bold;
      }
    .descripcion-tipo
      margin-bottom 5px
    .motivo
      word-wrap: break-word;
      background-color: #eff5fb;
      color: #296fa8;
      padding: 10px
    .botones
      display flex
      justify-content center
      margin-top 10px
      .button
        margin-right 5px
        &:last-child
          margin-right 0px
  .modal-sidebar-desktop-open
    width: calc(100% - 180px);
  @media (max-width 985px)
    .is-mobile
      display block

    .is-desktop
      display none
  @media (max-width: 820px)
    .modal-sidebar-desktop-open
      width: 100%;
</style>




// WEBPACK FOOTER //
// View_Gestion_Links_Importantes.vue?43700806